import { useEffect, useRef } from "react";
import { bool, func, string } from "prop-types";
import { useLocation } from "react-router-dom";

import Alert from "../../../styles/components/Alert";
import Article from "../../../styles/components/Article";
import Helmet from "react-helmet";
import Meta from "../../meta";

function ErrorBoundaryFallbackApp({ isChunkError, message, name, resetError }) {
  const { pathname } = useLocation();
  const initialPathname = useRef(pathname);

  useEffect(() => {
    if (!!resetError && pathname !== initialPathname.current) {
      resetError();
    }
  }, [pathname, resetError]);

  return (
    <>
      <Meta title={isChunkError ? "Site Update" : "Error"} />
      <Helmet defer={false}>
        <meta name="prerender-status-code" content="500" />
      </Helmet>
      <Article>
        <h1>{isChunkError ? "Site Update" : "Error"}</h1>
        <Alert type="error">
          {!isChunkError && name !== "Error" ? `${name}: ` : ""}
          {message}
        </Alert>
      </Article>
    </>
  );
}

ErrorBoundaryFallbackApp.propTypes = {
  isChunkError: bool,
  message: string,
  name: string,
  resetError: func,
};

export default ErrorBoundaryFallbackApp;
